import {
  Button,
  Col,
  Form,
  Row,
  Input,
  Select,
  Skeleton,
  Pagination,
  Table,
  Tabs,
  // DatePicker
} from "antd";
import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { FARE, RATE } from "../../config/constants/api";
// import moment from "moment";
import { Post } from "../../config/api/post";
import { Put } from "../../config/api/put";
import { Delete } from "../../config/api/delete";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { FaEdit, FaTrash } from "react-icons/fa";

const FareManagement = () => {
  const token = useSelector((state) => state.user.userToken);
  const [form] = Form.useForm();
  const [serviceType, setServiceType] = useState("Black");
  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);
  // const navigate = useNavigate();
  // const [open, setOpen] = useState(false);
  const [fares, setFares] = useState(null);
  const [rates, setRates] = useState(null);
  const [editingFareId, setEditingFareId] = useState(null);
  const [editingRateId, setEditingRateId] = useState(null);
  // const [filter, setFilter] = useState({
  //   status: null,
  //   type: null,
  //   keyword: "",
  //   from: null,
  //   to: null,
  // });
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const getFares = (pageNumber, pageSize, from, to, serviceType = "Black") => {
    setLoading(true);
    Get(FARE.getAllFares, token, {
      from,
      to,
      serviceType,
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
      isDistanceFare: true,
    })
      .then((response) => {
        if (response?.data?.docs) {
          setFares(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };
  const getRates = (pageNumber, pageSize, from, to, serviceType = "Black") => {
    setLoading(true);
    Get(RATE.getAllRates, token, {
      from,
      to,
      serviceType,
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
      //   isCompanyRate: true,
      isDistanceRate: true,
    })
      .then((response) => {
        if (response?.data?.docs) {
          setRates(response?.data?.docs);

          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getFares();
    getRates();
    // eslint-disable-next-line
  }, []);
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = fares
    ? `Showing records ${endIndex} of ${paginationConfig.totalDocs}`
    : "Showing records 0 of 0";
  // const handleOpenChange = (newOpen) => {
  //   setOpen(newOpen);
  // };
  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
    getFares(pageNumber, paginationConfig.limit);
  };
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }

    return originalElement;
  };
  // const handleFrom = (date) => {
  //   setFilter({
  //     ...filter,
  //     from: date,
  //   });
  // };

  // const handleTo = (date) => {
  //   setFilter({
  //     ...filter,
  //     to: date,
  //   });
  // };
  // const data = {
  //   status: filter.status,
  //   keyword: filter.keyword,
  //   from: filter.from,
  //   to: filter.to,
  // };
  // const handleApply = () => {
  //   let from;
  //   let to;
  //   if (data.from) {
  //     from = moment(filter?.from?.$d).format("YYYY-MM-DD");
  //   }
  //   if (data.to) {
  //     to = moment(filter?.to?.$d).format("YYYY-MM-DD");
  //   }
  //   if (from || to) {
  //     getUsers(
  //       paginationConfig.pageNumber,
  //       paginationConfig.limit,
  //       from,
  //       to,
  //       serviceType
  //     );
  //   } else {
  //     return;
  //   }
  // };
  // const resetFilter = () => {
  //   setFilter({
  //     status: null,
  //     keyword: "",
  //     from: null,
  //     to: null,
  //   });
  // };
  // const handleClear = () => {
  //   resetFilter();
  //   getUsers();
  // };
  // const filterContent = (
  //   <div className="filterDropdown">
  //     <div>
  //       <p
  //         className="mainLabel"
  //         style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
  //       >
  //         Filter
  //       </p>
  //     </div>
  //     <hr style={{ marginBottom: 10 }} />

  //     <div className="filterDropdownBody">
  //       <p className="mainLabel">From:</p>
  //       <DatePicker
  //         className="mainInput filterInput web-input"
  //         value={filter.from}
  //         onChange={(e) => handleFrom(e)}
  //         style={{ width: "100%" }}
  //       />
  //       <p className="mainLabel">To:</p>
  //       <DatePicker
  //         className="mainInput filterInput web-input"
  //         value={filter.to}
  //         onChange={(e) => handleTo(e)}
  //         style={{ width: "100%" }}
  //       />
  //       <Button
  //         type=""
  //         block
  //         size={"large"}
  //         style={{ marginBottom: "10px" }}
  //         className="web-btn"
  //         //   onClick={() => getUsers()}
  //         onClick={handleApply}
  //       >
  //         Apply
  //       </Button>
  //       <Button
  //         type=""
  //         block
  //         size={"large"}
  //         className="web-btn"
  //         onClick={handleClear}
  //       >
  //         Clear All
  //       </Button>
  //     </div>
  //   </div>
  // );
  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          S.NO
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Passenger Capacity
        </p>
      ),
      dataIndex: "passengerCapacity",
      key: "passengerCapacity",
      render: (item) => <span>{item}</span>,
    },
    // {
    //   title: (
    //     <p className="uppercase font-euclid text-black font-bold text-sm text-center">
    //       Date
    //     </p>
    //   ),
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   render: (item) => <span>{dayjs(item).format("M/D/YYYY")}</span>,
    // },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          fare per Mile
        </p>
      ),
      dataIndex: "farePerMile",
      key: "farePerMile",
      render: (value, item, index) => (
        <p className="text-sm text-center font-euclid text-[#575757]">
          {item.farePerMile}
        </p>
      ),
    },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Per Min Rate
        </p>
      ),
      dataIndex: "farePerMile",
      key: "farePerMile",
      render: (value, item, index) => {
        const matchedRate =
          rates &&
          rates.find(
            (rate) =>
              rate.serviceType === item.serviceType &&
              rate.passengerCapacity === item.passengerCapacity &&
              rate.inCity === item.inCity
          );
        const perMinRate = matchedRate ? matchedRate?.perMinuteRate : "N/A";

        return (
          <p className="text-sm text-center font-euclid text-[#575757]">
            ${perMinRate}
          </p>
        );
      },
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-sm text-center">
          Apply
        </p>
      ),
      dataIndex: "inCity",
      key: "inCity",
      render: (value, item, index) => {
        if (!item.inCity !== null && item.inCity !== undefined) {
          console.log(item.inCity);
          // checks for both null and undefined
          return (
            <p className="text-sm text-center font-euclid text-[#575757]">
              {item.inCity ? "In City" : "Out of City"}
            </p>
          );
        }
        return null; // hide the cell
      },
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => {
        const matchedRate =
          rates &&
          rates.find(
            (rate) =>
              rate.serviceType === item.serviceType &&
              rate.passengerCapacity === item.passengerCapacity &&
              rate.inCity === item.inCity
          );
        const perMinRate = matchedRate ? matchedRate?.perMinuteRate : "N/A";
        return (
          <div className="flex justify-center">
            <div className="flex justify-center bg-[#FDE6C3] rounded-[100%] w-fit p-2 mr-1">
              <FaEdit
                className="text-[#CD810D] cursor-pointer h-[16px] w-[16px]"
                onClick={() => {
                  form.setFieldsValue({
                    farePerMile: item.farePerMile,
                    passengerCapacity: item.passengerCapacity,
                    serviceType: item.serviceType,
                    perMinuteRate: perMinRate,
                    inCity: item.inCity,
                  });
                  setServiceType(item.serviceType);
                  // Store IDs for update
                  setEditingFareId(item._id);
                  setEditingRateId(matchedRate?._id || null);
                }}
              />
            </div>
            <div className="flex justify-center bg-[#FEE2E2] rounded-[100%] w-fit p-2">
              <FaTrash
                className="text-[#DC2626] cursor-pointer h-[16px] w-[16px]"
                onClick={() => {
                  if (matchedRate) {
                    handleDelete(
                      item._id,
                      matchedRate._id,
                      item.serviceType,
                      item.passengerCapacity,
                      item.inCity
                    );
                  } else {
                    Swal.fire({
                      title: "Error!",
                      text: "Rate not found for this record. Cannot delete.",
                      icon: "error",
                      confirmButtonColor: "#d33",
                    });
                  }
                }}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const onFinish = async (values) => {
    console.log("Form values:", values);
    console.log("Service type:", serviceType);
    console.log("perMinuteRate value:", values?.perMinuteRate);
    console.log("perMinuteRate type:", typeof values?.perMinuteRate);
    
    const isEditingFare = !!editingFareId;
    const isEditingRate = !!editingRateId;
    
    const rateData = {
      hourlyRate: Number(values?.perMinuteRate) * 60,
      perMinuteRate: Number(values?.perMinuteRate),
      serviceType,
      passengerCapacity: Number(values?.passengerCapacity),
      isDistanceRate: true,
      inCity: values?.inCity,
    };
    
    const fareData = {
      farePerMile: values?.farePerMile,
      serviceType,
      passengerCapacity: values?.passengerCapacity,
      isDistanceFare: true,
      inCity: values?.inCity,
    };
    
    console.log("Rate API data:", rateData);
    console.log("perMinuteRate in API data:", rateData.perMinuteRate);
    console.log("Is editing fare:", isEditingFare);
    console.log("Is editing rate:", isEditingRate);
    console.log("Editing Rate ID:", editingRateId);
    
    try {
      // Update or create rate
      let rateResponse;
      if (isEditingRate) {
        rateResponse = await Put(`${RATE.updateRate}/${editingRateId}`, token, rateData);
      } else {
        rateResponse = await Post(RATE.addRate, rateData, token);
      }
      
      if (rateResponse?.status) {
        console.log("Rate updated/created successfully");
        // Refresh rates
        await getRates(
          paginationConfig.pageNumber,
          paginationConfig.limit,
          null,
          null,
          serviceType
        );
      } else {
        throw new Error(rateResponse?.message || "Failed to update/create rate");
      }

      // Update or create fare (include rate data for distance fares)
      let fareResponse;
      if (isEditingFare) {
        // Include rate information in fare update for distance fares
        const combinedFareData = {
          ...fareData,
          rateId: editingRateId,
          perMinuteRate: rateData.perMinuteRate,
          hourlyRate: rateData.hourlyRate,
        };
        fareResponse = await Put(`${FARE.updateFare}/${editingFareId}`, token, combinedFareData);
      } else {
        fareResponse = await Post(FARE.addFare, fareData, token);
      }
      
      if (fareResponse?.status) {
        swal("System Alert!", fareResponse?.message || "Record saved successfully", "success");
        form.resetFields();
        setEditingFareId(null);
        setEditingRateId(null);
        const newActiveKey = serviceTypeTabMap[serviceType];
        if (newActiveKey) {
          setActiveTab(newActiveKey);
        }
        // Refresh fares
        await getFares(
          paginationConfig.pageNumber,
          paginationConfig.limit,
          null,
          null,
          serviceType
        );
      } else {
        throw new Error(fareResponse?.message || "Failed to update/create fare");
      }
    } catch (err) {
      console.error("Error:", err);
      const errorMessage = err?.response?.data?.message || err?.message || "An error occurred. Please try again.";
      swal("Oops!", errorMessage, "error");
    }
  };
  const serviceTypeTabMap = {
    Black: "1",
    Ultra: "2",
    "Ultra Beyond": "3",
    Suv: "4",
    Sprinter: "5",
  };

  // const onChange = (checked) => {
  //   console.log(`switch to ${checked}`);
  // };

  const handleDelete = (fareId, rateId, serviceType, passengerCapacity, inCity) => {
    Swal.fire({
      title: "Are you sure?",
      html: `
        <p>You are about to delete this distance fare record.</p>
        <p><strong>Service Type:</strong> ${serviceType}</p>
        <p><strong>Passenger Capacity:</strong> ${passengerCapacity}</p>
        ${inCity !== null && inCity !== undefined ? `<p><strong>Location:</strong> ${inCity ? "In City" : "Out of City"}</p>` : ''}
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      focusConfirm: false,
      focusCancel: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // Show loading state
        Swal.fire({
          title: "Deleting...",
          text: "Please wait while we delete the record.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        Delete(
          FARE.deleteHourlyFareRecord,
          token,
          {
            fareId: fareId,
            rateId: rateId,
            serviceType: serviceType,
            passengerCapacity: passengerCapacity,
            inCity: inCity,
          }
        )
          .then((response) => {
            if (response?.success || response?.status) {
              // Refresh both fares and rates
              getFares(
                paginationConfig.pageNumber,
                paginationConfig.limit,
                null,
                null,
                serviceType
              );
              getRates(
                paginationConfig.pageNumber,
                paginationConfig.limit,
                null,
                null,
                serviceType
              );

              Swal.fire({
                title: "Deleted!",
                text: response?.message || "Record deleted successfully.",
                icon: "success",
                confirmButtonColor: "#3085d6",
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: response?.message || "Failed to delete record.",
                icon: "error",
                confirmButtonColor: "#d33",
              });
            }
          })
          .catch((err) => {
            const errorMessage =
              err?.response?.data?.message ||
              err?.message ||
              "Failed to delete record. Please try again.";

            Swal.fire({
              title: "Error!",
              text: errorMessage,
              icon: "error",
              confirmButtonColor: "#d33",
            });
          });
      }
    });
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setServiceType(value);
  };
  const onChange = (value) => {
    let serviceType;
    if (value === "1") {
      serviceType = "Black";
    } else if (value === "2") {
      serviceType = "Ultra";
    } else if (value === "3") {
      serviceType = "Ultra Beyond";
    } else if (value === "4") {
      serviceType = "Suv";
    }
    else if (value === "5") {
      serviceType = "Sprinter";
    }
    setServiceType(serviceType);
    // let from;
    // let to;
    // if (data.from) {
    //   from = moment(filter?.from?.$d).format("YYYY-MM-DD");
    // }
    // if (data.to) {
    //   to = moment(filter?.to?.$d).format("YYYY-MM-DD");
    // }

    getFares(
      paginationConfig.pageNumber,
      paginationConfig.limit,
      null,
      null,
      serviceType
    );
    getRates(
      paginationConfig.pageNumber,
      paginationConfig.limit,
      null,
      null,
      serviceType
    );
  };
  const items = [
    {
      key: "1",
      label: "Black Luxury",
      children: (
        <Row justify="left">
          <Col xxl={19} xs={22}>
            <div>
              <Row style={{ overflow: "auto" }} className="px-6">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Skeleton active />
                    <br />
                  </div>
                ) : (
                  <Table
                    className="styledTable"
                    dataSource={fares}
                    columns={columns}
                    pagination={false}
                  />
                )}
              </Row>
              <Row style={{ padding: "10px 20px" }}>
                <Col xs={24} xl={12}>
                  <p className="font-euclid text-sm text-black">{message}</p>
                </Col>
                <Col
                  xs={24}
                  xl={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Pagination
                    className="styledPagination"
                    onChange={(e) => handlePageChange(e)}
                    current={parseInt(paginationConfig.pageNumber)}
                    pageSize={paginationConfig.limit}
                    total={paginationConfig.totalDocs}
                    itemRender={itemRender}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      key: "2",
      label: "Ultra Luxury",
      children: (
        <Row justify="left">
          <Col xxl={19} xs={22}>
            <div>
              <Row style={{ overflow: "auto" }} className="px-6">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Skeleton active />
                    <br />
                  </div>
                ) : (
                  <Table
                    className="styledTable"
                    dataSource={fares}
                    columns={columns}
                    pagination={false}
                  />
                )}
              </Row>
              <Row style={{ padding: "10px 20px" }}>
                <Col xs={24} xl={12}>
                  <p className="font-euclid text-sm text-black">{message}</p>
                </Col>
                <Col
                  xs={24}
                  xl={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Pagination
                    className="styledPagination"
                    // onChange={(e) => handlePageChange(e)}
                    current={parseInt(paginationConfig.pageNumber)}
                    pageSize={paginationConfig.limit}
                    total={paginationConfig.totalDocs}
                    itemRender={itemRender}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      key: "3",
      label: "Ultra Beyond Luxury",
      children: (
        <Row justify="left">
          <Col xxl={19} xs={22}>
            <div>
              <Row style={{ overflow: "auto" }} className="px-6">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Skeleton active />
                    <br />
                  </div>
                ) : (
                  <Table
                    className="styledTable"
                    dataSource={fares}
                    columns={columns}
                    pagination={false}
                  />
                )}
              </Row>
              <Row style={{ padding: "10px 20px" }}>
                <Col xs={24} xl={12}>
                  <p className="font-euclid text-sm text-black">{message}</p>
                </Col>
                <Col
                  xs={24}
                  xl={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Pagination
                    className="styledPagination"
                    // onChange={(e) => handlePageChange(e)}
                    current={parseInt(paginationConfig.pageNumber)}
                    pageSize={paginationConfig.limit}
                    total={paginationConfig.totalDocs}
                    itemRender={itemRender}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      key: "4",
      label: "SUV Luxury",
      children: (
        <Row justify="left">
          <Col xxl={19} xs={22}>
            <div>
              <Row style={{ overflow: "auto" }} className="px-6">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Skeleton active />
                    <br />
                  </div>
                ) : (
                  <Table
                    className="styledTable"
                    dataSource={fares}
                    columns={columns}
                    pagination={false}
                  />
                )}
              </Row>
              <Row style={{ padding: "10px 20px" }}>
                <Col xs={24} xl={12}>
                  <p className="font-euclid text-sm text-black">{message}</p>
                </Col>
                <Col
                  xs={24}
                  xl={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Pagination
                    className="styledPagination"
                    onChange={(e) => handlePageChange(e)}
                    current={parseInt(paginationConfig.pageNumber)}
                    pageSize={paginationConfig.limit}
                    total={paginationConfig.totalDocs}
                    itemRender={itemRender}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      key: "5",
      label: "Sprinter",
      children: (
        <Row justify="left">
          <Col xxl={19} xs={22}>
            <div>
              <Row style={{ overflow: "auto" }} className="px-6">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Skeleton active />
                    <br />
                  </div>
                ) : (
                  <Table
                    className="styledTable"
                    dataSource={fares}
                    columns={columns}
                    pagination={false}
                  />
                )}
              </Row>
              <Row style={{ padding: "10px 20px" }}>
                <Col xs={24} xl={12}>
                  <p className="font-euclid text-sm text-black">{message}</p>
                </Col>
                <Col
                  xs={24}
                  xl={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Pagination
                    className="styledPagination"
                    onChange={(e) => handlePageChange(e)}
                    current={parseInt(paginationConfig.pageNumber)}
                    pageSize={paginationConfig.limit}
                    total={paginationConfig.totalDocs}
                    itemRender={itemRender}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-4 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-between items-center mx-4 lg:mx-8">
            <div className="flex justify-center items-center">
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Distance Fare Management
              </h3>
            </div>
            {/* <Popover
              content={filterContent}
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
              placement="bottomRight"
              arrow={false}
            >
              <Button
                style={{
                  padding: "4px 11px",
                  height: "auto",
                  borderRadius: "6px",
                  backgroundColor: "white",
                }}
              >
                <MdTune className="text-[32px] text-[#767676]" />
              </Button>
            </Popover> */}
          </div>

          <Row className="mt-8">
            <Col xs={22} sm={18} md={16} lg={12} xxl={12} className="fareForm">
              <Form
                form={form}
                name="editUser"
                onFinish={onFinish}
                layout="vertical"
                className="w-full px-8 max-xl:px-2 customSelect1"
              >
                <Row gutter={[16, 0]} justify="left">
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="farePerMile"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Type to Add Fare Charges per Mile
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please input your last name!",
                        },
                      ]}
                    >
                      {/* <Select
                          defaultValue="USD"
                          className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs w-fit mr-2"
                          suffixIcon={<TiArrowSortedDown />}
                          onChange={handleChange}
                          style={{ width: "fit-content" }}
                          options={[
                            {
                              label: (
                                <span className="font-euclid text-sm text-black">
                                  USD
                                </span>
                              ),
                              value: "usd",
                            },
                            // {
                            //   label: (
                            //     <span className="font-euclid text-sm text-black">
                            //       Euro
                            //     </span>
                            //   ),
                            //   value: "euro",
                            // },
                          ]}
                        /> */}
                      <Input
                        placeholder="Enter Fare Charges"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="number"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="perMinuteRate"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Type per min Rate
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please input per min Rate!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter per min Rate"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="number"
                        onWheel={(e) => e.target.blur()}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="serviceType"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Select Service Type
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please input Service Type!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select"
                        className="h-12 text-sm font-euclid w-full bg-gray-100 max-sm:text-xs"
                        onChange={handleChange}
                        options={[
                          {
                            label: (
                              <span className="font-euclid text-sm text-black">
                                Black Luxury
                              </span>
                            ),
                            value: "Black",
                          },
                          {
                            label: (
                              <span className="font-euclid text-sm text-black">
                                Ultra Luxury
                              </span>
                            ),
                            value: "Ultra",
                          },
                          {
                            label: (
                              <span className="font-euclid text-sm text-black">
                                Ultra Beyond Luxury
                              </span>
                            ),
                            value: "Ultra Beyond",
                          },
                          {
                            label: (
                              <span className="font-euclid text-sm text-black">
                                SUV Luxury
                              </span>
                            ),
                            value: "Suv",
                          },
                          {
                            label: (
                              <span className="font-euclid text-sm text-black">
                                Sprinter
                              </span>
                            ),
                            value: "Sprinter",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="passengerCapacity"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Type Passenger Capacity
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please input Passenger Capacity!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Passenger Capacity"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        autoComplete={false}
                        type="number"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="inCity"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Select In City or Out of City
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please input In City or Out of City",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select"
                        className="h-12 text-sm font-euclid w-full bg-gray-100 max-sm:text-xs"
                        options={[
                          {
                            label: (
                              <span className="font-euclid text-sm text-black">
                                In City
                              </span>
                            ),
                            value: true,
                          },
                          {
                            label: (
                              <span className="font-euclid text-sm text-black">
                                Out of City
                              </span>
                            ),
                            value: false,
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="left">
                  <Col lg={12}>
                    <Form.Item className="self-center text-left">
                      <Button
                        htmlType="submit"
                        className="uppercase bg-button hover:bg-white hover:border-customGold hover:border-2 font-euclid font-bold text-white px-14 h-[50px] hover:text-customGold text-center text-sm new-hover"
                      >
                        {loading ? "LOADING..." : "save now"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>

          <Row justify="left" className="mt-8 mx-4 lg:mx-8">
            <Col xs={24} sm={22} md={21} xl={20}>
              {rates && fares && (
                <Tabs
                  activeKey={activeTab}
                  items={items}
                  onChange={(key) => {
                    setActiveTab(key);
                    onChange(key);
                  }}
                  className="fare-tabs"
                />
              )}
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FareManagement;
